import { render, staticRenderFns } from "./ClientSwitcher.vue?vue&type=template&id=18a83890&scoped=true&"
import script from "./ClientSwitcher.vue?vue&type=script&lang=js&"
export * from "./ClientSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ClientSwitcher.vue?vue&type=style&index=0&id=18a83890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a83890",
  null
  
)

export default component.exports